import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import PaymentController from '../controllers/PaymentController';
import { statusDispatch } from './globalActions';
import { PaymentPlans } from '../helpers/Constants';
import { ICancelSubscriptionParams } from '../models/PaymentModels';

const paymentPrefix = 'payment';

export const paymentActions = {
  getIntentSecret: `${paymentPrefix}/get/intentSecret`,
  cancelSubscription: `${paymentPrefix}/cancel/subscription`,
  upgradePackage: `${paymentPrefix}/upgrade/package`,
  paymentResetValue: `${paymentPrefix}/reset/value`,
  getBookingStatus: `${paymentPrefix}/get/bookingStatus`,
  getTransactionsPdf: `${paymentPrefix}/get/transactionsPdf`,
  getInvoiceById: `${paymentPrefix}/get/invoice-pdf`,
  resumeSubscription: `${paymentPrefix}/resume/subscription`,
};

export const getIntentSecret = createAsyncThunk(
  paymentActions.getIntentSecret,
  async (plan: PaymentPlans, { rejectWithValue }) => {
    try {
      const resp = await PaymentController.getIntentSecret(plan);
      return statusDispatch(resp, rejectWithValue);
    } catch (err) {
      return rejectWithValue;
    }
  }
);

export const cancelSubscription = createAsyncThunk(
  paymentActions.cancelSubscription,
  async (params: ICancelSubscriptionParams, { rejectWithValue }) => {
    try {
      const resp = await PaymentController.cancelSubscription(params);
      return statusDispatch(resp, rejectWithValue);
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const resumeSubscription = createAsyncThunk(
  paymentActions.resumeSubscription,
  async (_, { rejectWithValue }) => {
    try {
      const resp = await PaymentController.resumeSubscription();
      return statusDispatch(resp, rejectWithValue);
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const upgradePackage = createAsyncThunk(
  paymentActions.upgradePackage,
  async (_, { rejectWithValue }) => {
    try {
      const resp = await PaymentController.upgradePackage();
      return statusDispatch(resp, rejectWithValue);
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getBookingStatus = createAsyncThunk(
  paymentActions.getBookingStatus,
  async (bookingId: string, { rejectWithValue }) => {
    try {
      const resp = await PaymentController.getBookingStatus(bookingId);
      return statusDispatch(resp, rejectWithValue);
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getTransactionsPdf = createAsyncThunk(
  paymentActions.getTransactionsPdf,
  async (_, { rejectWithValue }) => {
    try {
      const resp = await PaymentController.getTransactionsPdf();
      return statusDispatch(resp, rejectWithValue);
    } catch (err) {
      return rejectWithValue;
    }
  }
);

export const getInvoiceById = createAsyncThunk(
  paymentActions.getInvoiceById,
  async (paymentId: string, { rejectWithValue }) => {
    try {
      const resp = await PaymentController.getInvoiceById(paymentId);
      return statusDispatch(resp, rejectWithValue);
    } catch (err) {
      return rejectWithValue;
    }
  }
);

export const paymentResetValue = createAction<Array<string>>(paymentActions.paymentResetValue);